export default __webpack_public_path__ + "static/media/superstar-kraver.6e0c36e8.svg";